<template>
    <div class="maskRights">
        <div class="maskRightsBox">
            <i class="close"></i>
            <div class="scroll_box">
                <img style="margin: 0 auto 10px;" src="../assets/images/upgrade.svg" alt="Upgrade">
                <p class="tip"></p>
                <div class="tip_btn">
                    <a class="down" href="">{{$t("rightDown")}}</a>
                    <span class="MemberLogin">{{$t("Login")}}</span>
                    <span class="cancel">{{$t("Cancel")}}</span>
                    <span class="upgrade_btn">{{$t("Upgrade")}}</span>
                </div>
            </div>
        </div>
        <div class="maskRightsBuyBox">
            <i class="close"></i>
            <div class="scroll_box">
                <Buy />
            </div>
        </div>
        <div class="buySuccess">
            <i class="close"></i>
            <div class="scroll_box">
                <img src="../assets/images/success.svg" alt="Success">
                <p class="info Member">{{$t("buyUserInfo")}}</p>
                <p class="info noMember" v-html="this.$t('buyNoUserInfo')"></p>
                <span class="btn">{{$t("Close")}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import Buy from "@/components/buy"
export default {
    components:{
        Buy
    },
    mounted(){
        $('.tip_btn span.MemberLogin').click(function(){
            $('.maskRights').hide()
        })
        $('.tip_btn span.cancel').click(function(){
            $('.maskRights').hide()
        })
        $('.buySuccess .btn').click(function(){
            $('.maskRights').hide()
        })
        // 关闭权益
        $('.maskRights .close').click(function(){
            $('.maskRights').hide()
        })
        // 打开升级
        $('.tip_btn span.upgrade_btn').click(function(){
            $('.maskRightsBuyBox').show().siblings().hide()
        })
        // 打开注册弹窗
        $('body').on('click','.registerMaskbtn',function(){
            $('.maskRights').hide();
            $('.maskMember').show();
            $('.member>.register').addClass('active').siblings('.box').removeClass('active');
        });
        // 打开登录弹框
        $('body').on('click','.loginMaskbtn',function(){
            $('.maskRights').hide();
            $('.maskMember').show();
            $('.member>.login').addClass('active').siblings('.box').removeClass('active');
        })
    }
}
</script>

<style>

/* 打开权益窗口 */
.maskRights{background: rgba(0, 0, 0, .6);width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;padding: 10px;box-sizing: border-box;display: none;z-index: 100;}

.maskRightsBox,.maskLoginTips,.maskLoginMonitor,.maskRightsBuyBox{display: none;}

.maskRightsBox,.maskLoginTips,.maskLoginMonitor,.maskLoginMonitor,.maskRightsBuyBox,.buySuccess{border-radius: 10px;padding: 0px 10px 0px;box-sizing: border-box;background: #fff;height: 100%;position: relative;}
.maskRights .scroll_box{overflow-y: auto;height: 100%;box-sizing: border-box;padding-left: 110px;padding-right: 110px;padding-top: 30px;padding-bottom: 96px;height: auto;max-height: 100%;margin-left: -10px;position: absolute;top: 50%;left: 50%;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);width: 100%;}
.maskRightsBuyBox .scroll_box{padding-top: 66px;}
.maskRightsBox .tip{font-size: 20px;color: #333;line-height: 32px;text-align: center;}
.maskRightsBox .tip span{font-weight: bold;color: #21a1f2;}
.maskRightsBox .tip.error_403.Member span{font-weight: bold;color: #333;}
.maskRightsBox .tip.error_400 span{text-decoration: underline;font-weight: normal;cursor: pointer;}
.maskRightsBox .tip a{color: #21a1f2;}
.maskRightsBox .tip a:hover{color: #33c3f3;}
.maskRightsBox .tip a:active{color: #21a1f2;}
.maskRightsBox .tip i{display: block;margin-top: 10px;}
.maskRightsBox .tip i span{cursor: pointer;}
.maskRightsBox .noDown span{text-decoration: underline;cursor: pointer;}
.maskRightsBox .noDown span{cursor: pointer;}
.maskRightsBox .resolutionImage{font-size: 16px;color: #333;line-height: 26px;text-align: center;margin-top: 6px;display: none;}
.maskRightsBox .resolutionImage *{display: none;cursor: pointer;}
.maskRightsBox .resolutionImage *{color: #333;border: 1px solid #00a0fe;font-size: 18px;line-height: 34px;text-decoration: none !important;color: #00a0fe;display: inline-block;padding-left: 20px;padding-right: 20px;border-radius: 6px;margin-top: 6px;}
.maskRightsBox .resolutionImage a:hover{color: #333;}
.maskRightsBox .box{margin: 20px auto 0px;-webkit-align-items: top;align-items: top;-webkit-justify-content: center;justify-content: center;max-width: 1200px;width: 100%;}
.maskRightsBox.active .box .rights{display: none;}
.maskRightsBox.active .box{max-width: 800px;width: 100%;}
.maskRights .close{width: 20px;height: 20px;background: url(../assets/images/close.svg);position: absolute;top: 20px;right: 25px;cursor: pointer;z-index: 9;}
.maskRights .close:hover{background: url(../assets/images/close-h.svg);}

.maskLoginTips>div,.maskLoginMonitor>div{position: absolute;top: 50%;left: 50%;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);text-align: center;}
.maskLoginTips,.maskLoginMonitor{padding-top: 50px;}
.maskLoginTips img{margin: auto;display: block;}
.maskLoginTips p,.maskLoginMonitor p{font-size: 18px;line-height: 28px;color: #333;max-width: 952px;width: 100%;text-align: center;}
.maskLoginTips p a{font-weight: bold;}
.maskLoginTips .btn,.tip_btn *{min-width: 240px;height: 50px;line-height: 50px;text-align: center;border-radius: 34px;background: #21a1f2;display: inline-block;margin: 20px auto;font-size: 22px;color: #fff;cursor: pointer;padding-left: 70px;padding-right: 70px;box-sizing: border-box;}
.maskLoginTips .btn:hover,.tip_btn *:hover{background: #33c3f3;text-decoration: none;}

.maskLoginMonitor .img{position: relative;margin: 0px  auto 14px;display: block;width: 100px;height: 100px;}
.maskLoginMonitor .img img:first-child{position: absolute;top: 50%;left: 50%;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
.maskLoginMonitor .img img:last-child{-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;position: absolute;top: 0px;left: 0px;}

.buySuccess{text-align: center;}
.buySuccess img{margin: auto;display: block;}
.buySuccess p{font-size: 18px;line-height: 28px;color: #333;max-width: 952px;width: 100%;text-align: center;margin: auto;}
.buySuccess p span{font-weight: bold;color: #21a1f2;cursor: pointer;}
.buySuccess .btn{min-width: 240px;height: 50px;line-height: 50px;text-align: center;border-radius: 34px;background: #21a1f2;display: inline-block;margin: 20px auto;font-size: 22px;color: #fff;cursor: pointer;padding-left: 70px;padding-right: 70px;box-sizing: border-box;}
.buySuccess .btn:hover{background: #33c3f3;text-decoration: none;}
/* 旋转 */
@-webkit-keyframes rotate {0% {-webkit-transform: rotate(0deg)}100% {-webkit-transform: rotate(360deg)}}
@-moz-keyframes rotate {0% {-moz-transform: rotate(0deg)}100% {-moz-transform: rotate(360deg)}}
@-o-keyframes rotate {0% {-o-transform: rotate(0deg)}100% {-o-transform: rotate(360deg)}}
.maskLoginMonitor .btn{min-width: 318px;padding-left: 30px;padding-right: 30px;box-sizing: border-box;border: 1px solid #21a1f2;border-radius: 34px;line-height: 48px;font-size: 20px;color: #21a1f2;display: inline-block;margin-top: 20px;}
.maskLoginMonitor .btn:hover{background: rgba(255, 104, 2, 0.09);text-decoration: none;}
.tip_btn{
    margin-top: 20px;
    text-align: center;
}
.tip_btn *{
    margin: 10px;
}
.tip_btn .down{
    display: none;
}
.tip_btn span.cancel,.tip_btn .down{
    background: none;
    border: 1px solid #21a1f2;
    line-height: 48px;
    color: #21a1f2;
}
.tip_btn span.cancel:hover,.tip_btn .down:hover{
    background: #21a1f2;
    color: #fff;
}
@media screen and (max-width:980px){
    .maskRights .scroll_box{
        padding-left: 10px;
        padding-right: 10px;
        margin-left: 0px;
    }
}
</style>